import { GET } from '@/request/index'
import URL from '@/request/api/url'
/**
 * 获取新闻详情和招聘岗位详情
 * @param {id} id
 * @returns
 */
export const fetchRecruitmentDetail = (id) => {
  return GET(URL.RECRUITMENT_DETAIL + id)
}

/**
 * 获取新闻列表
 * @returns
 */
export const fetchNewList = () => {
  return GET(URL.NEWS_LIST)
}
